import { useRef } from 'react';
import { IonModal } from '@ionic/react';
import FlowModalHeader from './FlowModalHeader';
import { focusStepHeading } from './ModalPages/StepLayout';
import { appStore, modalToggleStore, toggleStore } from '../../store/Store';
import ApplyPermit0 from './ModalPages/ApplyPermit0';
import ApplyPermit1 from './ModalPages/ApplyPermit1';
import ApplyPermit2 from './ModalPages/ApplyPermit2';
import ApplyPermit3 from './ModalPages/ApplyPermit3';
import ApplyPermit4 from './ModalPages/ApplyPermit4';
import ApplyPermit5 from './ModalPages/ApplyPermit5';
import ApplyPermit6 from './ModalPages/ApplyPermit6';
import '../../theme/FlowModal.css';

export const PERMIT_STEPS = 6;

const STEP_COMPONENTS = [
    ApplyPermit0,
    ApplyPermit1,
    ApplyPermit2,
    ApplyPermit3,
    ApplyPermit4,
    ApplyPermit5,
    ApplyPermit6,
];

/**
 * The permit application: a readiness check (page 0) followed by six counted
 * steps. The current page lives in modalToggleStore so each step can advance
 * itself; this component owns Back, Close and the reset when the modal closes.
 */
function PermitModal({ setModalOpen, modalOpen }) {
    const permitPage = modalToggleStore.useState((s) => s.permitPage);
    const modalRef = useRef(null);
    const Step = STEP_COMPONENTS[permitPage] || ApplyPermit0;

    const closeModal = () => {
        setModalOpen(false);
    };

    const goBack = () => {
        modalToggleStore.update((s) => {
            s.permitPage = Math.max(0, s.permitPage - 1);
        });
    };

    // Closing part-way through starts the next application from the top,
    // instead of re-opening on a stale step with stale answers.
    const resetFlow = () => {
        modalToggleStore.update((s) => {
            s.permitPage = 0;
        });
        toggleStore.update((s) => {
            s.agreeRules = false;
            s.manualAddress = false;
            s.chooseAddressToggle = 'auto';
        });
        appStore.update((s) => {
            s.addressPass = true;
        });
    };

    const handleDismiss = () => {
        resetFlow();
        closeModal();
    };

    // Ionic focuses the modal element itself once the enter animation ends;
    // hand focus on to the first step's heading after that.
    const handlePresent = () => {
        window.setTimeout(() => focusStepHeading(modalRef.current), 0);
    };

    return (
        <IonModal
            ref={modalRef}
            className='flow-modal'
            isOpen={modalOpen}
            onDidDismiss={handleDismiss}
            onDidPresent={handlePresent}
        >
            <FlowModalHeader
                title={
                    permitPage > 0 ? `Step ${permitPage} of ${PERMIT_STEPS}` : 'Are you ready to apply?'
                }
                step={permitPage}
                totalSteps={PERMIT_STEPS}
                onBack={permitPage > 0 ? goBack : undefined}
                onClose={closeModal}
                closeLabel='Close permit application'
            />
            <Step />
        </IonModal>
    );
}

export default PermitModal;
